import { appLocationId } from "config/envConfig";
import { timezoneConfig } from "config/timezoneConfig";
import { createContext, useContext, useEffect, useState } from "react";
import apiList from "services/apiList";
import { callApi } from "services/callApi";
import { KIOSK_DETAILS } from "utils/Constants";
import { getLocalStorage, setLocalStorage } from "utils/storageUtil";

const ConfigContext = createContext();

export const useConfig = () => {
  return useContext(ConfigContext);
};

export const ConfigLocalKey = "config";
export const defaultCurrencyConfig = {
  currencyCode: "INR",
  currencySymbol: "₹",
};

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(getLocalStorage(ConfigLocalKey) || {});

  const [currency, setCurrency] = useState(
    config.currencySymbol || defaultCurrencyConfig.currencySymbol
  );
  const [timezone, setTimezone] = useState(
    config.timezone || timezoneConfig["in"]
  );

  const fetchConfigs = async () => {
    try {
      const kioskDetails = getLocalStorage(KIOSK_DETAILS) || {};
      const locationId = kioskDetails?.locationId || appLocationId;
      let apiURL = apiList.appOperatingLocation.locationDetails;
      let apiResponse = await callApi.get(apiURL);
      if (apiResponse?.status === 200) {
        setConfigs(apiResponse?.data);
        return apiResponse?.data;
      } else {
        setConfigs({});
        return {};
      }
    } catch (e) {
      console.log(e);
      return {};
    }
  };

  const setConfigs = (configs) => {
    const configObj = JSON.parse(JSON.stringify(configs));
    // let timezone = timezoneConfig["in"];
    // if (configObj?.countryCode) {
    //   timezone = timezoneConfig[configObj.countryCode.toLowerCase()];
    // }
    // configObj.timezone = timezone;

    window.dispatchEvent(new Event("storage"));

    setLocalStorage(ConfigLocalKey, configObj);
    setConfig(configObj);
    setTimezone(configObj.timezone);
    setCurrency(configObj.currencySymbol);
  };

  useEffect(() => {
    fetchConfigs();
  }, []);

  const value = {
    currency,
    timezone,
    config,
  };

  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
};
